import { RowSelectionState } from "@tanstack/react-table";
import { Dispatch, ReactNode, SetStateAction, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";

export type TableSelectActionElements = (selectedRows: string[]) => ReactNode;

type TableSelectionActionsProps = {
  selectedRows: RowSelectionState;
  setSelectedRows: Dispatch<SetStateAction<RowSelectionState>>;
  selectActions?: TableSelectActionElements;
};

// TODO: center in table instead of page

const TableSelectionActions = ({
  selectedRows,
  setSelectedRows,
  selectActions,
}: TableSelectionActionsProps) => {
  const { t } = useTranslation();
  const selectedCount = Object.keys(selectedRows).length;

  const selectedIds = useMemo(
    () =>
      Object.entries(selectedRows)
        .filter(([, val]) => val === true)
        .map(([id]) => id),
    [selectedRows],
  );

  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-8 transform -translate-x-1/2 left-1/2 z-50">
      <div className="bg-white rounded-md shadow-md p-4 flex items-center gap-32">
        <div className="flex flex-row gap-4 items-center">
          <div className="font-semibold text-base text-nowrap">
            {selectedCount} {t("tableItemsSelected")}
          </div>
          <Button
            variant="link"
            size="sm"
            onClick={() => setSelectedRows({})}
            className="underline text-[#005D8D] font-semibold text-sm text-nowrap"
          >
            {t("tableUnselectAll")}
          </Button>
        </div>

        {selectActions?.(selectedIds)}
      </div>
    </div>
  );
};

export default TableSelectionActions;
